const handleDeleteFrequencyFormParamFreq = {
  confirm: 'Deseja realmente deletar o item',
  title: 'DELETAR ITEM'
};

export default handleDeleteFrequencyFormParamFreq;
